import { render, staticRenderFns } from "./howitworks.vue?vue&type=template&id=1c0600a2&scoped=true&"
import script from "./howitworks.vue?vue&type=script&lang=js&"
export * from "./howitworks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0600a2",
  null
  
)

export default component.exports